export const quote = [
  'You can do it!',
  'Come on, your nearly there!',
  'Believe in yourself',
  'If you are brave enough to START, then you are strong enough to FINISH',
  'Nothing is impossible, the word itself says “I’m possible”!',
  "'Finished last' is always better than 'did not finsh'",
  'Act as if what you do makes a difference. IT DOES.',
  "Believe you can and you're halfway there",
  'What you can do today can improve all your tomorrows',
  'Die with memories not dreams',
];
